import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { accessService } from '../../services/central-api/access';

interface Props {
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    zIndex: number;
}

export default function CameraDropdown({ value, setValue, zIndex }: Props) {
    const [items, setItems] = useState<{ label: string; value: string; }[]>([]);

    async function getItems() {
        try {
            const cameras = await accessService.getAllCameras({});
            setItems(cameras.map((camera) => {
                return {
                    value: camera.id,
                    label: camera.title
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getItems();
    }, []);

    return (
        <FilterDropdown
            label={translate('camera')}
            items={items}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
        />
    );
}
